/**
 * pendingVerificationStore.ts — ponte efêmera entre o login bloqueado por e-mail não
 * verificado e a tela de código (/signup/verify).
 *
 * Guarda só em memória (sem persist): a senha nunca deve sobreviver a um reload de página
 * nem tocar localStorage/sessionStorage. Existe só para permitir, depois do código
 * confirmado, refazer o login automaticamente em vez de mandar o usuário para o login de
 * novo — ele já digitou email e senha corretos uma vez, não deveria digitar de novo.
 */

import { create } from "zustand"

type PendingVerificationState = {
  email: string | null
  password: string | null
  set: (email: string, password: string) => void
  clear: () => void
}

export const usePendingVerificationStore = create<PendingVerificationState>((set) => ({
  email: null,
  password: null,
  set: (email, password) => set({ email, password }),
  clear: () => set({ email: null, password: null }),
}))
